import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { array, object, string } from "yup";
import { QuestionBankFormValues } from "src/models/QuestionBank.model";
import QuestionBankForm from "../Layouts/QuestionBankForm";
import { showToast } from "src/utils/showToaster";
import { useAddQuestionsMutation } from "src/services/QuestionBankServices";
type Props = {
  onClose: () => void;
};

const AddQuestionBankFormWrapper = ({ onClose }: Props) => {
  const [saveNextChecked, setSaveNextChecked] = useState(true);

  const [addQuestions] = useAddQuestionsMutation();

  // Form Initial Values
  const initialValues: QuestionBankFormValues = {
    question: "",
    tagId:[],
    title: "",
    complexity: "",
    order: "",
    explanationVideoURL: '',
    solution: '',
    solutionVideoURL:'' ,
    hintVideoUrl :'' ,
  };

  // Validation Schema
  const validationSchema = object().shape({
    question: string().required("Please enter question"),
    title: string().required("Please enter title"),
    order: string().required("Please enter order"),
    complexity: object().required("Please enter complexity"),
    tagId: array().required("Please enter Tag"),
  });

  // Handle Submit
  const handleSubmit = (
    values: QuestionBankFormValues,
    { setSubmitting, resetForm }: FormikHelpers<QuestionBankFormValues>
  ) => {
    const formatedValue = {
      question: values?.question,
      tags : values?.tagId,
      title: values?.title,
      complexity: values?.complexity?.value,
      order: values?.order,
      explanationVideoUrl: values?.explanationVideoURL,
      solution: values?.solution ,
      solutionVideoUrl:values?.solutionVideoURL ,
      hintVideoUrl  : values?.hintVideoUrl ,
    };

    addQuestions(formatedValue).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          if (!saveNextChecked) {
            resetForm();
            onClose();
          }
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="lg" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <QuestionBankForm
              formikProps={formikProps}
              onClose={onClose}
              formType="Add"
              setSaveNextChecked={setSaveNextChecked}
              saveNextChecked={saveNextChecked}
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddQuestionBankFormWrapper;
